import React from 'react';
//import Dashboard from '../components/Dashboard/Dashboard';

const TemplatesPage = () => {
  return <div>Templates Page</div>; 
};

export default TemplatesPage;
